import { render, staticRenderFns } from "./NewsBox.vue?vue&type=template&id=3740a392&scoped=true&"
import script from "./NewsBox.vue?vue&type=script&lang=js&"
export * from "./NewsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3740a392",
  null
  
)

export default component.exports